import React from 'react';
import { Shield, CheckCircle, Award } from 'lucide-react';

const OurBalloons = () => {
  const safetyFeatures = [
    'British-built ballooning equipment',
    'Annual rigorous safety checks by KCAA',
    'Comprehensive pre-flight inspections',
    'Regular maintenance schedules',
    'State-of-the-art navigation systems',
    'Emergency procedures training'
  ];

  return (
    <div className="min-h-screen pt-20">
      <section
        className="relative h-96 flex items-center justify-center text-white"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/2563596/pexels-photo-2563596.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl md:text-6xl font-bold">Our Balloons</h1>
          <p className="text-xl mt-4">Safety, Quality, and Excellence</p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex justify-center mb-6">
              <Shield className="w-20 h-20" style={{ color: '#EE6A1F' }} />
            </div>
            <h2 className="text-4xl font-bold text-gray-800 mb-6">SAFETY</h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Safety is at the heart of everything we do. Our commitment to maintaining the highest safety standards is unwavering.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img
                src="https://images.pexels.com/photos/29865515/pexels-photo-29865515.jpeg"
                alt="Hot air balloon"
                className="rounded-lg shadow-xl"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-800 mb-6">Our Fleet</h3>
              <p className="text-gray-700 leading-relaxed mb-6">
                Our fleet consists of British-built hot air balloons, renowned worldwide for their quality, reliability, and safety standards. Each balloon is meticulously maintained and undergoes regular inspections.
              </p>
              <p className="text-gray-700 leading-relaxed">
                We work exclusively with manufacturers who share our commitment to excellence, ensuring that every piece of equipment meets or exceeds international aviation standards.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 bg-stone-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center">
            Safety Features & Protocols
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {safetyFeatures.map((feature, index) => (
              <div key={index} className="flex items-start space-x-4 bg-white p-6 rounded-lg shadow">
                <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
                <span className="text-gray-700 font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center mb-6">
                <Award className="w-12 h-12 mr-4" style={{ color: '#EE6A1F' }} />
                <h2 className="text-3xl font-bold text-gray-800">KCAA Certification</h2>
              </div>
              <p className="text-gray-700 leading-relaxed mb-6">
                The Kenyan Civil Aviation Authority (KCAA) conducts rigorous annual inspections of our entire fleet and operations.
              </p>
              <p className="text-gray-700 leading-relaxed">
                This unwavering commitment to safety has been a cornerstone of our operations since 1976, giving our guests complete peace of mind as they embark on their adventure.
              </p>
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1628164957603-a2020963168f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxhZnJpY2FuJTIwc3VucmlzZSUyMHNhdmFubmFofGVufDB8fHx8MTc2MzA3MTEwMHww&ixlib=rb-4.1.0&q=85"
                alt="Balloon inspection"
                className="rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 text-white" style={{ backgroundColor: '#EE6A1F' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6">British Engineering Excellence</h2>
          <p className="text-xl leading-relaxed">
            We exclusively use British-built balloons and equipment, recognized globally for their superior engineering, durability, and safety features.
          </p>
        </div>
      </section>
    </div>
  );
};

export default OurBalloons;
